import React, { useState, useEffect, useContext, useMemo } from "react";
import DataTable from 'react-data-table-component';
import { LuEye, LuTrash2, LuSearch, LuPencil } from "react-icons/lu";
//import { RoleForm } from "../../../components/masters/role/manageRole";
import { IoCalendarOutline } from "react-icons/io5";
import masterApi from "../../../services/masterApi";
import { useHeaderTitle } from '../../layout/layout';
import { AddUser } from "./AddUser";
import './user.scss';
import { FunctionalityNames } from "../../../enum/enum";
import { getPermissionRights} from "../../../utils/common";
import { AuthContext } from "../../../context/AuthContext";
import { toast } from 'react-toastify';

export default function UserList({setIsLoading}) {
    const REACT_APP_SEARCH_TEXT_LIMIT = process.env.REACT_APP_SEARCH_TEXT_LIMIT;

    const { rolePermissions } = useContext(AuthContext);
    const [userListPerm, setUserListPerm] = useState({});
    
    const [isPopupupVisible, setIsPopupupVisible] = useState(false);
    const [userList, setUserList] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalRecords, setTotalRecords] = useState(10);
    const [totalPages, setTotalPage] = useState(10);
    const { setHeaderTitle } = useHeaderTitle();
    const [selectedRowID,setSelectedRowId]=useState("");
    const [isViewMode, setIsViewMode] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const columns = [
        {
            name: 'Name',
            selector: (row) => row.firstName + ' ' + row.lastName,
            width: "200px",
        },
        {
            name: 'Designation',
            selector: (row) => row.designationTitle,
            width: "170px",
        },
        {
            name: 'Role',
            selector: (row) => row.roleName,
            width: "170px",
        },
        {
            name: 'Email',
            selector: (row) => row.email,
            width: "250px",
        },
        {
            name: 'Added On',
            width: "125px",
            selector: (row) => {
                const date = new Date(row.createdAt);
                return date.toLocaleDateString('en-GB'); // 'en-GB' formats as dd-mm-yyyy
            }
        },
        {
            name: 'Created by',
            selector: (row) => row.createdByUser,
            width: "200px",
        },{
            name: 'Status',
            selector: (row) => row.recordStatus,
            width: "200px",
        },
        {
            name: "Action",
            width: "150px",
            sortable: false,
            button: true,
            right: true,
            cell: (row) => (
                <div className="gridIcons d-flex gap-2 justify-content-center pe-5" data-tag="allowRowEvents">
                    {userListPerm?.edit === 1 && (
                    <button
                        type="button"
                        className="btn plain-btn-primary view-btn secondary-color"
                        title="Details"
                        onClick={() => handleEditClick(row)}
                        >
                        <LuPencil />
                    </button>
                    )}
                    {userListPerm?.view === 1 && (
                    <button
                        type="button"
                        className="btn plain-btn-primary view-btn primary-color"
                        title="View"
                        onClick={() => handleViewClick(row)}
                    >
                        <LuEye />
                    </button>
                    )}
                    {/* {userListPerm?.delete === 1 && (
                    <button
                        type="button"
                        className="btn plain-btn-primary reddish-color"
                        title="Delete"
                        onClick={() => handleDeleteClick(row)}
                    >
                        <LuTrash2 />
                    </button>
                    )} */}
                </div>
            ),
        }
    ];


    useEffect(() => {
        setHeaderTitle("User Management");
        fetchData(currentPage, searchText);
    }, [rowsPerPage,isPopupupVisible]);

    const fetchData = async (page, searchtxt) => {
        try {
            setIsLoading(true)
            let queryString = `?pageIndex=${page}&pageLimit=${rowsPerPage}&searchText=${searchtxt}`;
            const response = await masterApi.getAllUsers(queryString);
            // debugger
            let userList = response?.data?.users;
            setUserList(userList)
            let totalRecordsCount = userList?.[0]?.totalRecords || 0;
            //alert(totalRecordsCount/rowsPerPage)
            setTotalRecords(totalRecordsCount);
            setTotalPage(Math.ceil(totalRecordsCount / rowsPerPage));
        } catch (error) {

        } finally {
            setIsLoading(false)
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter" && (searchText.trim().length >= REACT_APP_SEARCH_TEXT_LIMIT || searchText.trim().length == 0)) {
            fetchData(currentPage, searchText);
        }
    };
    const handleInputChange = (e) => {
        const value = e.target.value;
        setSearchText(value);    
        if (value.trim().length >= REACT_APP_SEARCH_TEXT_LIMIT || value.trim().length === 0) {
            fetchData(currentPage, value); // or just fetchData(value) if page doesn't matter
        }
    };
    const handlePageChange = (page) => {
        setCurrentPage(page);
        fetchData(page, searchText);
    };

    const handleRowsPerPageChange = (rowsPerPage) => {
        setRowsPerPage(rowsPerPage);
        setCurrentPage(1); // Reset to page 1 when rows per page changes
        fetchData(currentPage, searchText);
    };
    const showPopup = () => {
        setSelectedRowId(null);
        setIsPopupupVisible(true);
    };

    const hidePopup = () => {
        setIsPopupupVisible(false);
        setIsViewMode(false);
        setIsEditMode(false);
    };
    const handleDeleteClick = async (row) => {
        var userConfirmation = window.confirm("Are you sure you want to delete this user?");
        if (userConfirmation){
            try {
                const response = await masterApi.deleteUser(row.id);
                if (response?.ok) {
                    // alert("User deleted successfully");
                    fetchData(currentPage, searchText);
                    toast.success("User deleted successfully", {
                        position: "top-right",
                        autoClose: 2000,
                      });
                } else {
                    // alert("Failed to delete user");
                    toast.error("Failed to delete user", {
                        position: "top-right",
                        autoClose: 2000,
                      });
                }
            } catch (error) {
                // console.error("Error deleting user:", error);
                toast.error("Something went wrong", {
                    position: "top-right",
                    autoClose: 2000,
                  });
            }
        }
    };
    const handleEditClick=(row)=>{
        setSelectedRowId(row.id);
        setIsPopupupVisible(true);
        setIsEditMode(true);
    }
    const handleViewClick=(row)=>{
        setIsViewMode(true);
        setSelectedRowId(row.id);
        setIsPopupupVisible(true);
    }
    useEffect(() => { 
        if (rolePermissions) {
            setUserListPerm(getPermissionRights(rolePermissions, FunctionalityNames.USERS));
        }
    }, [rolePermissions]);
    return (
        <section>            
            <section className="tool-bar d-flex align-items-center mb-3 gap-3">
                <div className="ms-auto position-absolute user-management-tool">
                    <div className="d-flex gap-2 align-items-center">
                        <div className="input-group search-container">
                            <input type="text" className="form-control" placeholder='Search' value={searchText} onChange={handleInputChange} onKeyDown={handleKeyDown} />
                            <button type="button" className="btn plain-btn-secondary"><LuSearch /></button>
                        </div>
                        {userListPerm?.create === 1 && (
                        <button type="button" className="btn btn-primary d-flex" onClick={showPopup}>Create User</button>
                        )}
                        </div>
                </div>
            </section>
            <section className="datatable-holder">
                <DataTable
                    columns={columns}
                    data={userList}
                    pagination
                    paginationServer
                    paginationTotalRows={totalRecords}
                    onChangePage={handlePageChange}
                    onChangeRowsPerPage={handleRowsPerPageChange}
                />
            </section>
            {/*isPopupupVisible && <RoleForm closePopup={hidePopup} loadRoleList={ fetchData} />*/}
            {isPopupupVisible && <AddUser closePopup={hidePopup} existingdata={selectedRowID} isViewMode={isViewMode}
                                          isEditMode={isEditMode}/>}
        </section>
    );
}
